$(document).ready(function () {
  $(".description").each(function () {
    var fullText = $(this).text().trim();
    var words = fullText.split(/\s+/);

    if (words.length > 25) {
      var visibleText = words.slice(0, 25).join(" ");
      var hiddenText = words.slice(25).join(" ");

      var html = `
            ${visibleText}<span class="dots">...</span>
            <span class="more-text" style="display:none;"> ${hiddenText}</span>
            <a href="#" class="read-more-toggle" style="cursor:pointer;"> Read more</a>
          `;

      $(this).html(html);
    }
  });

  $(document).on("click", ".read-more-toggle", function (e) {
    e.preventDefault();
    var $this = $(this);
    var $parent = $this.closest(".product__info-wrapper");

    $parent.find(".more-text").toggle();
    $parent.find(".dots").toggle();

    if ($this.text().trim() === "Read more") {
      $this.text(" Read less");
    } else {
      $this.text(" Read more");
    }
  });
});

document.addEventListener('DOMContentLoaded', function () {
    function updateVariantInfo(label) {
      const variantName = label.querySelector('.packname')?.textContent.trim();
      const price = label.querySelector('.actualptice')?.textContent.trim();
      const compareAtPrice = label.querySelector('.compareprice')?.textContent.trim();
      const pricedElement = document.querySelector('.priced');

      if (pricedElement) {
        pricedElement.innerHTML = price || '';
      }
    }
    
    document.body.addEventListener('change', function (event) {
      if (event.target.matches('input[type="radio"][name^="Pack of"]')) {
        const selectedRadio = event.target;
        const label = selectedRadio.nextElementSibling;
        if (label) {
          updateVariantInfo(label);
        }
      }
    });
  });

 $(document).ready(function () {
            const lenis = new Lenis({ smoothWheel: true, duration: 1.5, easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), })
            function raf(time) { lenis.raf(time); requestAnimationFrame(raf); }
            requestAnimationFrame(raf)
 })
$(document).ready(function () {
var other_elements = gsap.utils.toArray("[gsap-fadin-anim]");
other_elements.forEach(function (element) {
  let tl = gsap.timeline({
    scrollTrigger: {
      trigger: element,
      start: "top 95%",
      end: "bottom 50%",
      toggleActions: "play none none none",
    },
  });
  tl.fromTo(
    element,
    { opacity: 0, yPercent: 20 },
    { duration: 1, opacity: 1, yPercent: 0, ease: "cubic" }
  );
});
  
 var scale_elements = gsap.utils.toArray("[gsap-scale-anim]");
scale_elements.forEach(function (element) {
  let tl = gsap.timeline({
    scrollTrigger: {
      trigger: element,
      start: "top 95%",
      end: "bottom 50%",
      toggleActions: "play none none none",
    },
  });
  tl.fromTo(
    element,
    { opacity: 0, scale: 0.5 },
    { duration: 1, opacity: 1, scale: 1, ease: "cubic" }
  );
});
});
window.addEventListener("DOMContentLoaded", (event) => {
  let typeSplit = new SplitType("[text-split]", {
    types: "words, chars",
    tagName: "span"
  });
  function createScrollTrigger(triggerElement, timeline) {
    ScrollTrigger.create({
      trigger: triggerElement,
      onEnter: () => timeline.play()
    });
  }
  
    $("[letters-slide-up]").each(function (index) {
    let tl = gsap.timeline({ paused: true });
    tl.from($(this).find(".char"), { yPercent: 100, duration: 0.6, ease: "power3.out", stagger: { amount: 0.6 } });
    createScrollTrigger($(this), tl);
  });
    gsap.set("[text-split]", { opacity: 1 });
});

// $(document).ready(function() {
// 	        gsap.config({
// 	            autoSleep: 60,
// 	            nullTargetWarn: false,
// 	        });
// 	        gsap.registerPlugin(ScrollTrigger);

// 			$(".buttonss").hover(
// 			  	function() {
// 			    	gsap.to($(this).find('.button-arrow'), { translateX: '100%', duration: 0.3, background: '#005C50', color: '#FCFAF4' })
// 			  	}, 
// 			  	function() {
// 			  		gsap.to($(this).find('.button-arrow'), { translateX: '0%', duration: 0.3, background: '#FCFAF4', color: '#005C50' })
// 			  	}
// 			);
// 		})

var swiperThumbs = new Swiper(".thumb-swiper", {
  spaceBetween: 10,
  slidesPerView: 4,
  freeMode: true,
  watchSlidesProgress: true,
  breakpoints: {
    320: { slidesPerView: 5 },
    768: { slidesPerView: 7 },
    1024: { slidesPerView: 8 },
    1440: { slidesPerView: 10 },
  },
}); 
  // Initialize Swiper
  var swiperMain = new Swiper(".swiper.main-swiper", {
    slidesPerView: 1,
    spaceBetween: 16,
    pagination: {
      el: ".swiper-pagination-main",
      clickable: true,
    },
    thumbs: {
    swiper: swiperThumbs,
  },
    breakpoints: {
      320: { slidesPerView: 1, spaceBetween: 10 },
      499: { slidesPerView: 1, spaceBetween: 16 },
    },
  });

  // Initialize Magnific Popup
  $(".image-popup-vertical-fit").magnificPopup({
    type: "image",
    mainClass: "mfp-with-zoom",
    gallery: { enabled: true },
    zoom: {
      enabled: true,
      duration: 300,
      easing: "ease-in-out",
      opener: function (openerElement) {
        return openerElement.is("img") ? openerElement : openerElement.find("img");
      },
    },
  });
